import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, INSTAGRAM, OFFICE_LIST } from "@/data/site";

const COLS = [
  { title: "Taxi Services", links: [["Local Taxi", "/services/local-taxi-service"], ["Outstation Taxi", "/services/outstation-taxi-service"], ["One Way Taxi", "/services/one-way-taxi-service"], ["Airport Taxi", "/services/airport-taxi-service"], ["Sightseeing Taxi", "/sightseeing/rajasthan-sightseeing-taxi"], ["Rajasthan Taxi Service", "/rajasthan-taxi-service"]] },
  { title: "Main Office Locations", links: OFFICE_LIST.map((o) => [`Taxi Service in ${o.city}`, o.path]) },
  { title: "Quick Links", links: [["About", "/about"], ["Tours", "/tours"], ["Fleet", "/fleet"], ["Gallery", "/gallery"], ["Reviews", "/reviews"], ["FAQ", "/faq"], ["Blog", "/blog"], ["Contact", "/contact"], ["Booking", "/booking"]] },
];

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-ink pb-24 text-zinc-300 md:pb-0" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo light />
          <p className="mt-5 max-w-sm text-[15px] leading-relaxed">
            Lucky Taxi Service is a Rajasthan taxi booking company run by Lucky Choudhary, arranging local, outstation, one-way,
            sightseeing and multi-day tour taxis from offices in Jodhpur, Jaisalmer, Udaipur and Jaipur to every corner of the state.
          </p>
          <div className="mt-6 space-y-2 text-[15px]">
            <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2 hover:text-gold" data-testid="footer-phone"><Phone className="h-4 w-4 text-gold" aria-hidden />{PHONE_DISPLAY}</a>
            <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 break-all hover:text-gold" data-testid="footer-email"><Mail className="h-4 w-4 shrink-0 text-gold" aria-hidden />{EMAIL}</a>
            <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-gold" data-testid="footer-instagram"><Instagram className="h-4 w-4 text-gold" aria-hidden />@taxi_service_in_jodhpur</a>
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h2 className="font-sans text-xs font-semibold uppercase tracking-[0.22em] text-gold">{c.title}</h2>
            <ul className="mt-5 space-y-2.5">
              {c.links.map(([l, p]) => (
                <li key={p}><Link to={p} className="text-[15px] transition-colors hover:text-white" data-testid={`footer-link-${p.replace(/\//g, "-").replace(/^-/, "")}`}>{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="container-x grid gap-4 border-t border-white/10 py-8 sm:grid-cols-2 lg:grid-cols-4">
        {OFFICE_LIST.map((o) => (
          <p key={o.key} className="flex gap-2 text-[13px] leading-relaxed text-zinc-400"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden /><span><strong className="text-zinc-200">{o.city}:</strong> {o.address}</span></p>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col gap-3 py-6 text-[13px] text-zinc-400 md:flex-row md:items-center md:justify-between">
          <p>© {year} Lucky Taxi Service · Owner: Lucky Choudhary · {PHONE_DISPLAY} · {EMAIL}</p>
          <div className="flex gap-5">
            <Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="hover:text-white" data-testid="footer-terms">Terms &amp; Conditions</Link>
            <Link to="/tariff" className="hover:text-white" data-testid="footer-tariff">Tariff</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
